import styled from "styled-components";

export const Wrap = styled.div<{ $fullWidth?: boolean }>`
  position: relative;

  pointer-events: auto;
  flex-shrink: 0;
  width: ${({ $fullWidth }) => ($fullWidth ? "100%" : "auto")};
`;

export const Button = styled.button<{ $fullWidth?: boolean }>`
  position: relative;
  min-width: ${({ $fullWidth }) => ($fullWidth ? "0" : "220px")};
  width: ${({ $fullWidth }) => ($fullWidth ? "100%" : "auto")};
  height: ${({ $fullWidth }) => ($fullWidth ? "40px" : "44px")};
  padding: 0 16px 0 18px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.45);
  background: rgba(0, 0, 0, 0.35);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  cursor: pointer;
  user-select: none;
  box-sizing: border-box;
  pointer-events: auto !important;

  span {
    font-family: 'SpoqaHanSansNeo-Regular', 'Apple SD Gothic Neo', sans-serif;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.08em;
  }

  svg {
    flex: 0 0 auto;
  }
`;

export const PortalList = styled.div`
  position: fixed;
  z-index: 1000;
  background: #111111;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.45);
  pointer-events: auto !important;
  isolation: isolate;
`;

export const Item = styled.button`
  width: 100%;
  padding: 14px 18px;
  border: none;
  background: #111111;
  font-family: 'SpoqaHanSansNeo-Regular', 'Apple SD Gothic Neo', sans-serif;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #cfcfcf;
  text-align: left;
  cursor: pointer;
  user-select: none;
  transition: background 0.15s ease, color 0.15s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.06);
    color: #ffffff;
  }
`;
